<mat-dialog-title><b>Kontör Yükleme Geçmişi</b></mat-dialog-title>
<br />
<mat-card-subtitle>Son 10 Hareket Gösterilmektedir</mat-card-subtitle>
<mat-dialog-content>
  <div>
    <ejs-grid
      #gridListContourHistory
      [dataSource]="contourHistoryData"
      [rowHeight]="35"
      [gridLines]="gridLines"
    >
      <e-columns>
        <e-column field="serviceId" headerText="Hizmet" width="70">
          <ng-template #template let-contourHistoryData>
            <div *ngIf="contourHistoryData.serviceId === 0">
              <span>Ortak Hizmet</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 22">
              <span>EArşiv</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 24">
              <span>EFiş</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 2">
              <span>EFatura</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 52">
              <span>Eİrsaliye</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 42">
              <span>EBilet</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 72">
              <span>ESerbestMeslekMakbuzu</span>
            </div>
            <div *ngIf="contourHistoryData.serviceId === 82">
              <span>EMüstahsilMakbuzu</span>
            </div>
          </ng-template>
        </e-column>
        <e-column
          field="transactionTime"
          headerText="İşlem Tarihi"
          width="70"
          [format]="orderDateFormat"
        ></e-column>
        <e-column field="transactionType" headerText="İşlem Tipi" width="100">
          <ng-template #template let-contourHistoryData>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourInForPurchase'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(0, 255, 106)"
                >add</mat-icon
              >
              <span>Kontör Alımı Bakiye Artımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourInForUpdate'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(0, 255, 106)"
                >add</mat-icon
              >
              <span>Doküman Güncelleme Bakiye Artımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourInForDelete'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(0, 255, 106)"
                >add</mat-icon
              >
              <span>Doküman Silinmesi Bakiye Artımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourInForReturn'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(0, 255, 106)"
                >add</mat-icon
              >
              <span>Kontör İadesi Bakiye Artımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourOutForSales'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(231, 13, 24)"
                >minimize</mat-icon
              >
              <span>Satıştan Dolayı Bakiye Azalımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourOutForUpdate'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(231, 13, 24)"
                >minimize</mat-icon
              >
              <span>Doküman Güncellenmesi Bakiye Azalımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourOutForDelete'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(231, 13, 24)"
                >minimize</mat-icon
              >
              <span>Doküman Silinmesi Bakiye Azalımı</span>
            </div>
            <div
              *ngIf="
                contourHistoryData.transactionType === 'ContourOutForReturn'
              "
            >
              <mat-icon style="margin-left: -9px; color: rgb(231, 13, 24)"
                >minimize</mat-icon
              >
              <span>Kontör İadesi Bakiye Azalımı</span>
            </div>
          </ng-template>
        </e-column>
        <e-column field="partnerTitle" headerText="İş Ortağı Ünvanı" width="70">
        </e-column>
        <e-column field="contourCount" headerText="Kontör Sayısı" width="40">
        </e-column>
      </e-columns>
    </ejs-grid>
    <!-- <app-grid-list
      [gridId]="'grdContourHistory'"
      [listName]="'Kontör_Gecmisi'"
      [columnsList]="columnDefinition"
      [GridDataSource]="contourHistoryData"
      [isGridPdfShow]="false"
      [isDetailTemplateShow]="false"
      [isDetailTemplateTabShow]="true"
      [isCheckBoxShow]="false"
    >
    </app-grid-list> -->
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end" style="padding: 0">
  <button mat-raised-button matDialogClose color="primary">Kapat</button>
</mat-dialog-actions>
